import { v4 as uuidv4 } from 'uuid';

export class S3Uploader {
    constructor() {
        this.abort = this.abort.bind(this);
    }
    static async startUpload(tokenAccessor, userId, fi, progressHandler) {



        const s3Uploader = new S3Uploader();
        const prom = new Promise((resolve, reject) => {
            s3Uploader.uploadToS3(tokenAccessor, fi, userId, progressHandler, (f) => resolve(f), (err) => {
                reject(err);
            });
        });
        return { promise: prom, abort: s3Uploader.abort, file: fi };
    }
    ;
    region = "eu-west-1";
    uploadParallel = undefined;
    abort() {
        if (this.uploadParallel) {
            this.uploadParallel.abort();
        }
    }
    async uploadToS3(tokenAcessor, file, userId, progress, success, handleError) {
        
        const { fromCognitoIdentity } = await import('@aws-sdk/credential-provider-cognito-identity');
        const { XhrHttpHandler } = await import('@aws-sdk/xhr-http-handler');
        const { S3Client } = await import("@aws-sdk/client-s3");
        const { Upload } = await import('@aws-sdk/lib-storage');

        const tokendata = await tokenAcessor();
        const creds = fromCognitoIdentity({
            identityId: tokendata.IdentityId,
            clientConfig: { region: this.region },
            logins: {
                "cognito-identity.amazonaws.com": tokendata.Token
            }
        });
        const client = new S3Client({
            region: this.region,
            requestHandler: new XhrHttpHandler({}),
            credentials: creds,
        });
        const ext = /^.+\.([^.]+)$/.exec(file.name);
        const extension = ext == null ? "" : "." + ext[1];
        const key = userId + "_" + uuidv4() + extension;
        const params = {
            Bucket: tokendata.BucketName,
            Key: key,
            Body: file,
            region: this.region
        };
        this.uploadParallel = new Upload({
            client: client,
            queueSize: 4,
            partSize: 5 * 1024 * 1024, // optional size of each part§
            leavePartsOnError: false,
            params: params
        });
        this.uploadParallel.on("httpUploadProgress", pr => {
            progress({
                type: "uploadprogress",
                loaded: pr.loaded,
                total: pr.total,
            });
        });
        try {
            const data = await this.uploadParallel.done();
            success(data);
        }
        catch (error) {
            handleError(error);
        }
    };
}
